<template>
<div class="productSaleInfo" v-if="item">
  <div class="priceRanges" v-if="item.priceRanges">
    <div class="head">起批量</div><div class="head">商品价格</div>
    <template v-for="(row,i) in item.priceRanges">
      <div >{{row.startQuantity}}</div>
      <div >￥{{row.price}}</div>
    </template>

  </div>
  <div class="attributes">
    <div  v-if="item.supportOnlineTrade" >
      <span>支持网上交易:</span>{{statusToZH(item.supportOnlineTrade)}}
    </div>
    <div  v-if="item.amountOnSale" >
      <span>可售数量:</span>{{item.amountOnSale}}
    </div>
    <div  v-if="item.unit" >
      <span>计量单位:</span>{{item.unit}}
    </div>
    <div v-if="item.minOrderQuantity" >
      <span>最小起订量:</span>{{item.minOrderQuantity}}
    </div>
    <div  v-if="item.consignPrice" >
      <span>分销一件下单价格:</span>￥{{item.consignPrice}}
    </div>
    <div  v-if="item.cpsSuggestPrice" >
      <span>CPS建议价:</span>￥{{item.cpsSuggestPrice}}
    </div>
  </div>


</div>
</template>
<script >
import {statusToZH} from "../../config";

export default {
  methods: {statusToZH},
  props:{
    item:null,
  }
}
</script>
<style scoped>
.productSaleInfo{
  display: flex;
  flex-wrap: wrap;
  margin-top: 25px;
  align-items: flex-start;
}
.productSaleInfo .attributes{
  width: 49%;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}


.productSaleInfo .attributes > div{
  width: 99%;
  font-size: 12px;
  line-height: 18px;

}
.productSaleInfo .attributes > div span{
  font-weight: bold;
  width: 100px;
  text-align: right;
  display: inline-block;
  margin-right: 5px;
}
.productSaleInfo .priceRanges {
  --alibaba-bg-color: rgba(192, 196, 204, 0.5);
  --alibaba-border-color: rgba(192, 196, 204, 0.5);

  width: 49%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  border-top: 1px solid var(--alibaba-border-color);
  border-left: 1px solid var(--alibaba-border-color);
}
.productSaleInfo .priceRanges > div{
  border-bottom: 1px solid var(--alibaba-border-color);
  border-right: 1px solid var(--alibaba-border-color);
  padding: 5px;
  text-align: center;
}
.productSaleInfo .priceRanges .head{
  background-color: var(--alibaba-border-color);

}
</style>



// WEBPACK FOOTER //
// src/views/alibaba/product/components/productSaleInfo.vue